import { colors } from "../theme/colors";

export const months = [
  { name: "Enero", index: 0 },
  { name: "Febrero", index: 1 },
  { name: "Marzo", index: 2 },
  { name: "Abril", index: 3 },
  { name: "Mayo", index: 4 },
  { name: "Junio", index: 5 },
  { name: "Julio", index: 6 },
  { name: "Agosto", index: 7 },
  { name: "Septiembre", index: 8 },
  { name: "Octubre", index: 9 },
  { name: "Noviembre", index: 10 },
  { name: "Diciembre", index: 11 },
];

export const status = [
  { name: "received", index: 0 },
  { name: "new", index: 1 },
  { name: "modified", index: 2 },
  { name: "analisis", index: 3 },
  { name: "finished", index: 4 },
  { name: "rejected", index: 5 },
  { name: "", index: 6 },
];

export const statusColors = {
  new: "success",
  modified: "secondary",
  analisis: "primary",
  finished: "warning",
  rejected: "error",
  accepted: "success",
  received: "warning",
};

export const statusColorsHex = {
  rejected: { main: colors.red.main, contrast: colors.white.main },
  accepted: { main: colors.green.main, contrast: colors.white.main },
  received: { main: colors.yellow.main, contrast: colors.primary },
};

export const statusTranslate = {
  all: "Todos",
  received: "Recibida",
  new: "Nueva",
  modified: "Modificada",
  analisis: "En Análisis",
  finished: "Finalizada",
  rejected: "Rechazada",
  accepted: "Aceptada",
};

export const recommnedationStatus = [
  { name: "Todos", index: "" },
  { name: "Recibida", index: "received" },
  { name: "Aceptada", index: "accepted" },
  { name: "Rechazada", index: "rejected" },
];

export const originCountry = [
  { name: "all", index: "" },
  { name: "nat", index: "nat" },
  { name: "int", index: "int" },
];

export const originCountryTranslate = {
  all: "Todos",
  nat: "Nacional",
  int: "Internacional",
};

export const entityTypeTranslate = {
  individual: "Individual",
  juridic: "Juridica",
};

export const recommendationStatusTranslate = {
  received: "Recibida",
  accepted: "Aceptada",
  rejected: "Rechazada",
};

export const divisas = [
  { name: "Dólares", _id: "dollars" },
  { name: "Quetzales", _id: "quetzal" },
];

export const productService = [
  { name: "Producto", _id: "product" },
  { name: "Servicio", _id: "service" },
];

export const entityTypes = [
  { name: "Anónima", _id: "anonima" },
  { name: "Coletiva", _id: "colectiva" },
  { name: "Comandita Simple", _id: "comanditaSimple" },
  { name: "Comandita Simple con Acciones", _id: "comanditaSimpleConAcciones" },
  { name: "Responsabilidad Limitada", _id: "responsabilidadLimitada" },
  { name: "De Emprendimiento", _id: "deEmprendimiento" },
  { name: "Asociación y/o ONU", _id: "asociacionONU" },
  { name: "Institución y/o Entidad Publica", _id: "institucionEntidadPublica" },
  { name: "Institución Financiera", _id: "institucionFinanciera" },
  { name: "Otro (Especifique)", _id: "otro" },
];

export const typeCompany = [
  // { name: "Individual", _id: "individual" },
  { name: "Juridico", _id: "juridic" },
];

export const typeRegime = [
  { name: "Pagos Trimestrales", _id: "pagosTrimestrales" },
  { name: "Retención de Facturas", _id: "retencionFacturas" },
  { name: "Otros (Especifique)", _id: "otrosEspecifique" },
  { name: "No aplica", _id: "noAplica" },
];

export const providerType = [
  { name: "Nacional", _id: "nat" },
  { name: "Extranjero", _id: "int" },
];

export const companySize = [
  { name: "Micro", _id: 0 },
  { name: "Pequeña", _id: 1 },
  { name: "Mediana", _id: 2 },
  { name: "Grande", _id: 3 },
];

export const gender = [
  { name: "Masculino", _id: "m" },
  { name: "Femenino", _id: "f" },
];

export const maritalStatus = [
  { name: "Soltero/a", _id: "s" },
  { name: "Casado/a", _id: "c" },
  { name: "Unido/a", _id: "u" },
  { name: "Viudo/a", _id: "v" },
];

export const personalIdType = [
  { name: "Número de Identificación Tributaria (NIT)", _id: "nit" },
  { name: "DPI", _id: "dpi" },
  { name: "Pasaporte", _id: "passport" },
  { name: "Cédula", _id: "legacy" },
  { name: "RTU/RUT", _id: "rtu" },
];

export const personalIdType2 = [
  { name: "DNI", _id: "nit" },
  { name: "DPI", _id: "dpi" },
  { name: "Pasaporte", _id: "passport" },
  { name: "Cédula", _id: "legacy" },
];

export const typeShareholder = [
  { name: "Juridico", _id: "juridico" },
  { name: "Individual", _id: "individual" },
];

export const bussinessType = [
  { name: "Intermediario", _id: "intermediary" },
  { name: "Importador", _id: "importer" },
];

export const inmigrationStauts = [
  { name: "Residente Temporal", _id: "residenteTemporal" },
  { name: "Residente Permanente", _id: "residentePermanente" },
  { name: "Persona en tránsito", _id: "personaTransito" },
  { name: "Turísta o Visitante", _id: "turistaVisitante" },
  { name: "Permiso de trabajo", _id: "permisoTrabajo" },
  { name: "Permiso consular o similar", _id: "permisoConsular" },
  { name: "Otros (Especifique)", _id: "otrosEspecifique" },
];

export const newCpePeople = {
  name: {
    error: false,
    errorMessage: null,
    value: null,
  },
  position: {
    error: false,
    errorMessage: null,
    value: null,
  },
  typeId: {
    error: false,
    errorMessage: null,
    value: null,
  },
  id: {
    error: false,
    errorMessage: null,
    value: null,
  },
  nit: {
    error: false,
    errorMessage: null,
    value: null,
  },
};

export const newShareHolder = {
  name: {
    error: false,
    errorMessage: null,
    value: null,
  },
  commercialName: {
    error: false,
    errorMessage: null,
    value: null,
  },
  id: {
    error: false,
    errorMessage: null,
    value: null,
  },
  nit: {
    error: false,
    errorMessage: null,
    value: null,
  },
  social: {
    error: false,
    errorMessage: null,
    value: null,
  },
  country: {
    error: false,
    errorMessage: null,
    value: null,
  },
  percentage: {
    error: false,
    errorMessage: null,
    value: null,
  },
};

export const newCustomer = {
  address: {
    error: false,
    errorMessage: null,
    value: null,
  },
  name: {
    error: false,
    errorMessage: null,
    value: null,
  },
  country: {
    error: false,
    errorMessage: null,
    value: null,
  },
  phone: {
    error: false,
    errorMessage: null,
    value: null,
  },
  phoneExtension: {
    error: false,
    errorMessage: null,
    value: null,
  },
};

export const newPublicWrite = {
  folio: {
    error: false,
    errorMessage: null,
    value: null,
  },
  write: {
    error: false,
    errorMessage: null,
    value: null,
  },

  name: {
    error: false,
    errorMessage: null,
    value: null,
  },
  country: {
    error: false,
    errorMessage: null,
    value: null,
  },
  phone: {
    error: false,
    errorMessage: null,
    value: null,
  },
  phoneExtension: {
    error: false,
    errorMessage: null,
    value: null,
  },
};

export const newBiFamiliar = {
  firstName: {
    error: false,
    errorMessage: null,
    value: null,
  },
  secondName: {
    error: false,
    errorMessage: null,
    value: null,
  },
  otherNames: {
    error: false,
    errorMessage: null,
    value: null,
  },
};

export const newProductDetails = {
  type: {
    error: false,
    errorMessage: null,
    value: null,
  },
  address: {
    error: false,
    errorMessage: null,
    value: null,
  },
  // unitPrice: {
  //   error: false,
  //   errorMessage: null,
  //   value: null,
  // },
  deliveryTime: {
    error: false,
    errorMessage: null,
    value: null,
  },
  // hasWarranty: {
  //   error: false,
  //   errorMessage: null,
  //   value: null,
  // },
  // warrantyDetails: {
  //   error: false,
  //   errorMessage: null,
  //   value: null,
  // },
  // hasProductDevolution: {
  //   error: false,
  //   errorMessage: null,
  //   value: null,
  // },
  // productDevolutionDetails: {
  //   error: false,
  //   errorMessage: null,
  //   value: null,
  // },
  // hasTechnicalSupport: {
  //   error: false,
  //   errorMessage: null,
  //   value: null,
  // },
  // technicalSupportDetails: {
  //   error: false,
  //   errorMessage: null,
  //   value: null,
  // },
};

export const providerValues = {
  providerData: {
    generalInfo: {
      typeCompany: {
        error: false,
        errorMessage: null,
        value: null,
      },
      entityTypes: {
        error: false,
        errorMessage: null,
        value: null,
      },
      entityTypeDetails: {
        error: false,
        errorMessage: null,
        value: null,
      },
      typeRegime: {
        error: false,
        errorMessage: null,
        value: null,
      },
      regimeTypeDetails: {
        error: false,
        errorMessage: null,
        value: null,
      },
      nameOwnerCompany: {
        error: false,
        errorMessage: null,
        value: null,
      },
      name: {
        error: false,
        errorMessage: null,
        value: null,
      },
      commercialName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      nit: {
        error: false,
        errorMessage: null,
        value: null,
      },
      emailAccounting: {
        error: false,
        errorMessage: null,
        value: null,
      },
      creationCountry: {
        error: false,
        errorMessage: null,
        value: null,
      },
      managerName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      managerPhone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      managerPhoneExtension: {
        error: false,
        errorMessage: null,
        value: null,
      },
      managerEmail: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salerName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salerPhone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salerPhoneExtension: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salerEmail: {
        error: false,
        errorMessage: null,
        value: null,
      },
      economicActivity: {
        error: false,
        errorMessage: null,
        value: null,
      },
      companySize: {
        error: false,
        errorMessage: null,
        value: null,
      },
      agencies: {
        error: false,
        errorMessage: null,
        value: null,
      },
      address: {
        error: false,
        errorMessage: null,
        value: null,
      },
      country: {
        error: false,
        errorMessage: null,
        value: null,
      },
      state: {
        error: false,
        errorMessage: null,
        value: null,
      },
      city: {
        error: false,
        errorMessage: null,
        value: null,
      },
      zone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phoneExtension: {
        error: false,
        errorMessage: null,
        value: null,
      },
      email: {
        error: false,
        errorMessage: null,
        value: null,
      },
      website: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
    publicWrite: {
      number: {
        error: false,
        errorMessage: null,
        value: null,
      },
      date: {
        error: false,
        errorMessage: null,
        value: null,
      },
      notaryName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      register: {
        error: false,
        errorMessage: null,
        value: null,
      },
      folio: {
        error: false,
        errorMessage: null,
        value: null,
      },
      book: {
        error: false,
        errorMessage: null,
        value: null,
      },
      writeDate: {
        error: false,
        errorMessage: null,
        value: null,
      },
      record: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isModified: {
        error: false,
        errorMessage: null,
        value: null,
      },
      modifiedValues: {
        number: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        notaryName: {
          error: false,
          errorMessage: null,
          value: null,
        },
        register: {
          error: false,
          errorMessage: null,
          value: null,
        },
        writeDate: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    },
    tradePatent: {
      folio: {
        error: false,
        errorMessage: null,
        value: null,
      },
      book: {
        error: false,
        errorMessage: null,
        value: null,
      },
      date: {
        error: false,
        errorMessage: null,
        value: null,
      },
      record: {
        error: false,
        errorMessage: null,
        value: null,
      },
      register: {
        error: false,
        errorMessage: null,
        value: null,
      },
      folio2: {
        error: false,
        errorMessage: null,
        value: null,
      },
      book2: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
    companyPatent: {
      register: {
        error: false,
        errorMessage: null,
        value: null,
      },
      folio: {
        error: false,
        errorMessage: null,
        value: null,
      },
      book: {
        error: false,
        errorMessage: null,
        value: null,
      },
      record: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isStatal: {
        error: false,
        errorMessage: null,
        value: null,
      },
      statal: {
        number: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        authority: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      isCpe: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
  },
  legalRepresentative: {
    nationality: {
      error: false,
      errorMessage: null,
      value: null,
    },
    firstName: {
      error: false,
      errorMessage: null,
      value: null,
    },
    secondName: {
      error: false,
      errorMessage: null,
      value: null,
    },
    marriedName: {
      error: false,
      errorMessage: null,
      value: null,
    },
    firstLastName: {
      error: false,
      errorMessage: null,
      value: null,
    },
    secondLastName: {
      error: false,
      errorMessage: null,
      value: null,
    },
    otherNames: {
      error: false,
      errorMessage: null,
      value: null,
    },
    birthPlace: {
      error: false,
      errorMessage: null,
      value: null,
    },
    birthDate: {
      error: false,
      errorMessage: null,
      value: null,
    },
    gender: {
      error: false,
      errorMessage: null,
      value: null,
    },
    maritalStatus: {
      error: false,
      errorMessage: null,
      value: null,
    },
    occupation: {
      error: false,
      errorMessage: null,
      value: null,
    },
    idType: {
      error: false,
      errorMessage: null,
      value: null,
    },
    idNumber: {
      error: false,
      errorMessage: null,
      value: null,
    },
    issueCountry: {
      error: false,
      errorMessage: null,
      value: null,
    },
    issueState: {
      error: false,
      errorMessage: null,
      value: null,
    },
    issueCity: {
      error: false,
      errorMessage: null,
      value: null,
    },
    taxIdentification: {
      error: false,
      errorMessage: null,
      value: null,
    },
    phone: {
      error: false,
      errorMessage: null,
      value: null,
    },
    cellphone: {
      error: false,
      errorMessage: null,
      value: null,
    },
    email: {
      error: false,
      errorMessage: null,
      value: null,
    },
    migratoryStatus: {
      error: false,
      errorMessage: null,
      value: null,
    },
    migratoryStatusDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    address: {
      error: false,
      errorMessage: null,
      value: null,
    },
    workPermission: {
      error: false,
      errorMessage: null,
      value: null,
    },
    notarialAct: {
      error: false,
      errorMessage: null,
      value: null,
    },
    authNumber: {
      error: false,
      errorMessage: null,
      value: null,
    },
    legalRepresentativeAuthNumber: {
      error: false,
      errorMessage: null,
      value: null,
    },
    legalRepresentativeNumber: {
      error: false,
      errorMessage: null,
      value: null,
    },
    legalRepresentativeFolio: {
      error: false,
      errorMessage: null,
      value: null,
    },
    legalRepresentativeBookNumber: {
      error: false,
      errorMessage: null,
      value: null,
    },
    permissionWork: {
      error: false,
      errorMessage: null,
      value: null,
    },
    authDatePermissionWork: {
      error: false,
      errorMessage: null,
      value: null,
    },
    vaidateDatePermissionWork: {
      error: false,
      errorMessage: null,
      value: null,
    },
    actsAsMandatary: {
      error: false,
      errorMessage: null,
      value: null,
    },
  },
  economic: {
    isCpe: {
      error: false,
      errorMessage: null,
      value: null,
    },
    cpePeople: [
      {
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        position: {
          error: false,
          errorMessage: null,
          value: null,
        },
        id: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        typeOfShareholder: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nationality: {
          error: false,
          errorMessage: null,
          value: null,
        },
        appointmenDate: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    shareHolders: [
      {
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        commercialName: {
          error: false,
          errorMessage: null,
          value: null,
        },
        id: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        social: {
          error: false,
          errorMessage: null,
          value: null,
        },
        country: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    customers: [
      {
        address: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        country: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phoneExtension: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    publicWrite: [
      {
        folio: {
          error: false,
          errorMessage: null,
          value: null,
        },
        write: {
          error: false,
          errorMessage: null,
          value: null,
        },

        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        country: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phoneExtension: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    providerInfo: {
      address: {
        error: false,
        errorMessage: null,
        value: null,
      },
      name: {
        error: false,
        errorMessage: null,
        value: null,
      },
      country: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phoneExtension: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasStore: {
        error: false,
        errorMessage: null,
        value: null,
      },
      storeInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasSalesRoom: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salesRoomInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasLegalBenefits: {
        error: false,
        errorMessage: null,
        value: null,
      },
      legalBenefitsInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasAdditionalBenefits: {
        error: false,
        errorMessage: null,
        value: null,
      },
      additionalBenefits: {
        error: false,
        errorMessage: null,
        value: null,
      },
      additionalBenefitsPDF: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasEticCode: {
        error: false,
        errorMessage: null,
        value: null,
      },
      eticCodeInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      eticCodePDF: {
        error: false,
        errorMessage: null,
        value: null,
      },
      employsMinors: {
        error: false,
        errorMessage: null,
        value: null,
      },
      employsMinorsInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasIsoCertifications: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isoCertificationsInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isoCertificationsPDF: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasAdditionalActivities: {
        error: false,
        errorMessage: null,
        value: null,
      },
      additionalActivitiesInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      additionalActivitiesPDF: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isRelatedToBi: {
        error: false,
        errorMessage: null,
        value: null,
      },
      relatedToBiInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      applicantHasWorkedOnBi: {
        error: false,
        errorMessage: null,
        value: null,
      },
      applicantHasWorkedOnBiInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      BiProducts: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
  },
  otherInformation: {
    entityInfo: {
      clientName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      country: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      extension: {
        error: false,
        errorMessage: null,
        value: null,
      },
      pasiveIncome: {
        error: false,
        errorMessage: null,
        value: null,
      },
      pasiveIncomeOrigin: {
        error: false,
        errorMessage: null,
        value: null,
      },
      entityEconomicActivity: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isInTheStockMarket: {
        error: false,
        errorMessage: null,
        value: null,
      },
      stockMarketTicket: {
        error: false,
        errorMessage: null,
        value: null,
      },
      stockMarketBag: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isInternational: {
        error: false,
        errorMessage: null,
        value: null,
      },
      registrationDateMFA: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isInSIB: {
        error: false,
        errorMessage: null,
        value: null,
      },
      sibDate: {
        error: false,
        errorMessage: null,
        value: null,
      },
      sibCode: {
        error: false,
        errorMessage: null,
        value: null,
      },
      bussinessType: {
        error: false,
        errorMessage: null,
        value: null,
      },
      currency: {
        error: false,
        errorMessage: null,
        value: null,
      },
      anualSales: {
        error: false,
        errorMessage: null,
        value: null,
      },
      creditSales: {
        error: false,
        errorMessage: null,
        value: null,
      },
      spotSales: {
        error: false,
        errorMessage: null,
        value: null,
      },
      exportationSales: {
        error: false,
        errorMessage: null,
        value: null,
      },
      otherSales: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salesDetails: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salesCurrency: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salesPercentage: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
    badges: {
      income: {
        error: false,
        errorMessage: null,
        value: null,
      },
      outcome: {
        error: false,
        errorMessage: null,
        value: null,
      },
      incomeGTQ: {
        error: false,
        errorMessage: null,
        value: null,
      },
      incomeGTQDetails: {
        error: false,
        errorMessage: null,
        value: null,
      },
      outocmeGTQ: {
        error: false,
        errorMessage: null,
        value: null,
      },
      outcomeGTQDetails: {
        error: false,
        errorMessage: null,
        value: null,
      },
      incomeAnualDetails: {
        error: false,
        errorMessage: null,
        value: null,
      },
      outcomeAnualDetails: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
    customers: [
      {
        address: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        country: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phoneExtension: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    providerInfo: {
      address: {
        error: false,
        errorMessage: null,
        value: null,
      },
      name: {
        error: false,
        errorMessage: null,
        value: null,
      },
      country: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phoneExtension: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasStore: {
        error: false,
        errorMessage: null,
        value: null,
      },
      storeInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      employeesQuantity: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salesTeamSize: {
        error: false,
        errorMessage: null,
        value: null,
      },
      vehiclesQuantity: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasSalesRoom: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salesRoomInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasLegalBenefits: {
        error: false,
        errorMessage: null,
        value: null,
      },
      legalBenefitsInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasAdditionalBenefits: {
        error: false,
        errorMessage: null,
        value: null,
      },
      additionalBenefits: {
        error: false,
        errorMessage: null,
        value: null,
      },
      additionalBenefitsPDF: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasEticCode: {
        error: false,
        errorMessage: null,
        value: null,
      },
      eticCodeInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      eticCodePDF: {
        error: false,
        errorMessage: null,
        value: null,
      },
      employsMinors: {
        error: false,
        errorMessage: null,
        value: null,
      },
      employsMinorsInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasIsoCertifications: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isoCertificationsInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isoCertificationsPDF: {
        error: false,
        errorMessage: null,
        value: null,
      },
      hasAdditionalActivities: {
        error: false,
        errorMessage: null,
        value: null,
      },
      additionalActivitiesInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      additionalActivitiesPDF: {
        error: false,
        errorMessage: null,
        value: null,
      },
      isRelatedToBi: {
        error: false,
        errorMessage: null,
        value: null,
      },
      relatedToBiInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      applicantHasWorkedOnBi: {
        error: false,
        errorMessage: null,
        value: null,
      },
      applicantHasWorkedOnBiInfo: {
        error: false,
        errorMessage: null,
        value: null,
      },
      relatedToJudicialProcess: {
        error: false,
        errorMessage: null,
        value: null,
      },
      relatedToJudicialProcessDetails: {
        error: false,
        errorMessage: null,
        value: null,
      },
      BiProducts: {
        error: false,
        errorMessage: null,
        value: null,
      },
      juidicialProcessReason: {
        error: false,
        errorMessage: null,
        value: null,
      },
      juidicialProcessType: {
        error: false,
        errorMessage: null,
        value: null,
      },
      juidicialProcessDate: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
  },
  politicallyExposed: {
    people: [
      {
        firstSurname: {
          error: false,
          errorMessage: null,
          value: null,
        },
        secondSurname: {
          error: false,
          errorMessage: null,
          value: null,
        },
        marriedSurname: {
          error: false,
          errorMessage: null,
          value: null,
        },
        firstName: {
          error: false,
          errorMessage: null,
          value: null,
        },
        secondName: {
          error: false,
          errorMessage: null,
          value: null,
        },
        otherNames: {
          error: false,
          errorMessage: null,
          value: null,
        },
        gender: {
          error: false,
          errorMessage: null,
          value: null,
        },
        condition: {
          error: false,
          errorMessage: null,
          value: null,
        },
        local: {
          error: false,
          errorMessage: null,
          value: null,
        },
        company: {
          error: false,
          errorMessage: null,
          value: null,
        },
        position: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    actsInPersonal: {
      error: false,
      errorMessage: null,
      value: null,
    },
    actsInNameOf: {
      error: false,
      errorMessage: null,
      value: null,
    },
    isPep: {
      error: false,
      errorMessage: null,
      value: null,
    },
    wealthOrigin: {
      error: false,
      errorMessage: null,
      value: null,
    },
    isPepFamiliar: {
      error: false,
      errorMessage: null,
      value: null,
    },
    pepFamiliar: {
      error: false,
      errorMessage: null,
      value: null,
    },
    knowsAPep: {
      error: false,
      errorMessage: null,
      value: null,
    },
    knowsPepReason: {
      error: false,
      errorMessage: null,
      value: null,
    },
    knowsPepDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
  },
  productsInformation: {
    fundsOrigin: {
      error: false,
      errorMessage: null,
      value: null,
    },
    initialPrice: {
      error: false,
      errorMessage: null,
      value: null,
    },
    monthlyAmount: {
      error: false,
      errorMessage: null,
      value: null,
    },
    monthlyCredit: {
      error: false,
      errorMessage: null,
      value: null,
    },
    products: [
      {
        type: {
          error: false,
          errorMessage: null,
          value: null,
        },
        address: {
          error: false,
          errorMessage: null,
          value: null,
        },
        // unitPrice: {
        //   error: false,
        //   errorMessage: null,
        //   value: null,
        // },
        deliveryTime: {
          error: false,
          errorMessage: null,
          value: null,
        },
        // hasWarranty: {
        //   error: false,
        //   errorMessage: null,
        //   value: null,
        // },
        // warrantyDetails: {
        //   error: false,
        //   errorMessage: null,
        //   value: null,
        // },
        // hasProductDevolution: {
        //   error: false,
        //   errorMessage: null,
        //   value: null,
        // },
        // productDevolutionDetails: {
        //   error: false,
        //   errorMessage: null,
        //   value: null,
        // },
        // hasTechnicalSupport: {
        //   error: false,
        //   errorMessage: null,
        //   value: null,
        // },
        // technicalSupportDetails: {
        //   error: false,
        //   errorMessage: null,
        //   value: null,
        // },
      },
    ],
    hasWarranty: {
      error: false,
      errorMessage: null,
      value: null,
    },
    warrantyDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    hasProductDevolution: {
      error: false,
      errorMessage: null,
      value: null,
    },
    productDevolutionDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    hasTechnicalSupport: {
      error: false,
      errorMessage: null,
      value: null,
    },
    technicalSupportDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    canGiveDays: {
      error: false,
      errorMessage: null,
      value: null,
    },
    canGiveDaysDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
  },
  references: {
    personal: [
      {
        names: {
          error: false,
          errorMessage: null,
          value: null,
        },
        email: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        workPhone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        legalName: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        names: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        workPhone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        legalName: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        names: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        workPhone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        legalName: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    work: [
      {
        names: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        workPhone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        extension: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        names: {
          error: false,
          errorMessage: null,
          value: null,
        },
        phone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        workPhone: {
          error: false,
          errorMessage: null,
          value: null,
        },
        extension: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
  },
  documentation: {
    Escritura_Constitucion: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Patente_Comercio: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Patente_Empresa: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Escritura_Modificacion: {
      error: false,
      errorMessage: null,
      value: null,
    },
    RTU_Empresa: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Recibo_Servicio: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Nombramiento_Representante_Legal: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Registro_Mercantil: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Id_Representate_Legal: {
      error: false,
      errorMessage: null,
      value: null,
    },
    RTU_Representante_Legal: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Licencia_Ambiental: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Aceptacion_Mercaderia: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Acceso_Informacion: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Carta_de_Etica: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Aceptacion_Pago: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Servicios_Tecnicos: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Beneficiarios: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Codigo_Etica: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Proveedor_Extranjero: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Obligaciones_Servicios: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Datos_Corporativo: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Formulario_Representante_Legal: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Confirmacion_Datos_Empresa: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Declaracion_Proveedor: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Modificacion_Empresa: {
      error: false,
      errorMessage: null,
      value: null,
    },
    Representante_Legal: {
      error: false,
      errorMessage: null,
      value: null,
    },
  },
};

export const individualProviderValues = {
  personalData: {
    owner: {
      nationality: {
        error: false,
        errorMessage: null,
        value: null,
      },
      firstLastName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      secondLastName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      marriedName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      firstName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      secondName: {
        error: false,
        errorMessage: null,
        value: null,
      },
      otherNames: {
        error: false,
        errorMessage: null,
        value: null,
      },
      birthPlace: {
        error: false,
        errorMessage: null,
        value: null,
      },
      birthDate: {
        error: false,
        errorMessage: null,
        value: null,
      },
      origin: {
        error: false,
        errorMessage: null,
        value: null,
      },
      gender: {
        error: false,
        errorMessage: null,
        value: null,
      },
      maritalStatus: {
        error: false,
        errorMessage: null,
        value: null,
      },
      occupation: {
        error: false,
        errorMessage: null,
        value: null,
      },
      idType: {
        error: false,
        errorMessage: null,
        value: null,
      },
      idNumber: {
        error: false,
        errorMessage: null,
        value: null,
      },
      idOriginCountry: {
        error: false,
        errorMessage: null,
        value: null,
      },
      idOriginState: {
        error: false,
        errorMessage: null,
        value: null,
      },
      idOriginCity: {
        error: false,
        errorMessage: null,
        value: null,
      },
      rtu: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      cellPhoneCode: {
        error: false,
        errorMessage: null,
        value: null,
      },
      cellPhone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      address: {
        error: false,
        errorMessage: null,
        value: null,
      },
      country: {
        error: false,
        errorMessage: null,
        value: null,
      },
      state: {
        error: false,
        errorMessage: null,
        value: null,
      },
      city: {
        error: false,
        errorMessage: null,
        value: null,
      },
      zone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      colony: {
        error: false,
        errorMessage: null,
        value: null,
      },
      email: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
    migratoryStatus: {
      error: false,
      errorMessage: null,
      value: null,
    },
    migratoryStatusDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    workingPermission: {
      hasPermission: {
        error: false,
        errorMessage: null,
        value: null,
      },
      authNumber: {
        error: false,
        errorMessage: null,
        value: null,
      },
      date: {
        error: false,
        errorMessage: null,
        value: null,
      },
      vigency: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
  },
  sharesInfo: {
    workingData: {
      company: {
        error: false,
        errorMessage: null,
        value: null,
      },
      address: {
        error: false,
        errorMessage: null,
        value: null,
      },
      position: {
        error: false,
        errorMessage: null,
        value: null,
      },
      date: {
        error: false,
        errorMessage: null,
        value: null,
      },
      phone: {
        error: false,
        errorMessage: null,
        value: null,
      },
      salary: {
        error: false,
        errorMessage: null,
        value: null,
      },
      otherIncomes: {
        error: false,
        errorMessage: null,
        value: null,
      },
    },
    societies: [
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    juridicPeople: [
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        denomination: {
          error: false,
          errorMessage: null,
          value: null,
        },
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        nit: {
          error: false,
          errorMessage: null,
          value: null,
        },
        percentage: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
  },
  otherInfo: {
    isCpe: {
      error: false,
      errorMessage: null,
      value: null,
    },
    isImporter: {
      error: false,
      errorMessage: null,
      value: null,
    },
    anualSales: {
      error: false,
      errorMessage: null,
      value: null,
    },
    salesPercentage: {
      error: false,
      errorMessage: null,
      value: null,
    },
    cashSales: {
      error: false,
      errorMessage: null,
      value: null,
    },
    creditSales: {
      error: false,
      errorMessage: null,
      value: null,
    },
    otherSales: {
      error: false,
      errorMessage: null,
      value: null,
    },
    hasStore: {
      error: false,
      errorMessage: null,
      value: null,
    },
    storeInfo: {
      error: false,
      errorMessage: null,
      value: null,
    },
    hasSalesRoom: {
      error: false,
      errorMessage: null,
      value: null,
    },
    salesRoomInfo: {
      error: false,
      errorMessage: null,
      value: null,
    },
    employees: {
      error: false,
      errorMessage: null,
      value: null,
    },
    vehicles: {
      error: false,
      errorMessage: null,
      value: null,
    },
    deliveryTime: {
      error: false,
      errorMessage: null,
      value: null,
    },
    hasTecnicalSupport: {
      error: false,
      errorMessage: null,
      value: null,
    },
    tecnicalSupportDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    hasWarranty: {
      error: false,
      errorMessage: null,
      value: null,
    },
    warrantyDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    hasProductReplacement: {
      error: false,
      errorMessage: null,
      value: null,
    },
    productReplacementDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    productReplacementPDF: {
      error: false,
      errorMessage: null,
      value: null,
    },
    currency: {
      error: false,
      errorMessage: null,
      value: null,
    },
    BiProducts: {
      error: false,
      errorMessage: null,
      value: null,
    },
  },
  pep: {
    isPep: {
      error: false,
      errorMessage: null,
      value: null,
    },
    pepDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    isPepFamiliar: {
      error: false,
      errorMessage: null,
      value: null,
    },
    pepFamiliarDetails: {
      error: false,
      errorMessage: null,
      value: null,
    },
    hadJudicialProcess: {
      error: false,
      errorMessage: null,
      value: null,
    },
    judicialProcess: [
      {
        reason: {
          error: false,
          errorMessage: null,
          value: null,
        },
        type: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        status: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        reason: {
          error: false,
          errorMessage: null,
          value: null,
        },
        type: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        status: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        reason: {
          error: false,
          errorMessage: null,
          value: null,
        },
        type: {
          error: false,
          errorMessage: null,
          value: null,
        },
        date: {
          error: false,
          errorMessage: null,
          value: null,
        },
        status: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    knowsFinancialInstitution: {
      error: false,
      errorMessage: null,
      value: null,
    },
    financialInstitutionRelations: [
      {
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        details: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        details: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
      {
        name: {
          error: false,
          errorMessage: null,
          value: null,
        },
        details: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    knowsBiPeople: {
      error: false,
      errorMessage: null,
      value: null,
    },
    biPeople: [
      {
        firstName: {
          error: false,
          errorMessage: null,
          value: null,
        },
        secondName: {
          error: false,
          errorMessage: null,
          value: null,
        },
        otherNames: {
          error: false,
          errorMessage: null,
          value: null,
        },
      },
    ],
    position: {
      error: false,
      errorMessage: null,
      value: null,
    },
    date: {
      error: false,
      errorMessage: null,
      value: null,
    },
  },
  providerRequeriments: {
    id: {
      error: false,
      errorMessage: null,
      value: null,
    },
    rtu: {
      error: false,
      errorMessage: null,
      value: null,
    },
    acceptLetter: {
      error: false,
      errorMessage: null,
      value: null,
    },
    title: {
      error: false,
      errorMessage: null,
      value: null,
    },
    accessInfoAccept: {
      error: false,
      errorMessage: null,
      value: null,
    },
    services: {
      error: false,
      errorMessage: null,
      value: null,
    },
    application: {
      error: false,
      errorMessage: null,
      value: null,
    },
    statement: {
      error: false,
      errorMessage: null,
      value: null,
    },
    confirmation: {
      error: false,
      errorMessage: null,
      value: null,
    },
    infoActualization: {
      error: false,
      errorMessage: null,
      value: null,
    },
    servicesRecepit: {
      error: false,
      errorMessage: null,
      value: null,
    },
    servicesLetter: {
      error: false,
      errorMessage: null,
      value: null,
    },
    companyPatent: {
      error: false,
      errorMessage: null,
      value: null,
    },
    healthLicense: {
      error: false,
      errorMessage: null,
      value: null,
    },
    references: {
      error: false,
      errorMessage: null,
      value: null,
    },
    catalog: {
      error: false,
      errorMessage: null,
      value: null,
    },
  },
};

export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas (the)",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia (Plurinational State of)",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory (the)",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands (the)",
  "Central African Republic (the)",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands (the)",
  "Colombia",
  "Comoros (the)",
  "Congo (the Democratic Republic of the)",
  "Congo (the)",
  "Cook Islands (the)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czechia",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic (the)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands (the) [Malvinas]",
  "Faroe Islands (the)",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories (the)",
  "Gabon",
  "Gambia (the)",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (the)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (the Democratic People's Republic of)",
  "Korea (the Republic of)",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic (the)",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands (the)",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia (Federated States of)",
  "Moldova (the Republic of)",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands (the)",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger (the)",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands (the)",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines (the)",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of North Macedonia",
  "Romania",
  "Russian Federation (the)",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan (the)",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands (the)",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates (the)",
  "United Kingdom of Great Britain and Northern Ireland (the)",
  "United States Minor Outlying Islands (the)",
  "United States of America (the)",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela (Bolivarian Republic of)",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Åland Islands",
];
